import { Component } from '@angular/core'
import { Logo } from '../logo/logo'
import { NavItem } from '../../../shared/intefaces/interfaces'
import { RouterLink } from '@angular/router'
import { CallUsButton } from '../../../shared/components/call-us-button/call-us-button'

@Component({
	selector: 'app-footer',
	imports: [Logo, RouterLink, CallUsButton],
	templateUrl: './footer.html',
	styleUrl: './footer.css',
})
export class Footer {
	currentYear = new Date().getFullYear()

	companyItems: NavItem[] = [
		{
			label: 'Sell My Car',
			to: '/sell-my-car',
		},
		{
			label: 'About Us',
			to: '/about-us',
		},
		{
			label: 'How It Works',
			to: '/how-it-works',
		},
	]

  	legalItems: NavItem[] = [
		{
			label: 'Privacy Policy',
			to: 'https://www.radiusrecycling.com/legal-notices#privacy',
		},
		{
			label: 'Terms of Use',
			to: 'https://www.radiusrecycling.com/legal-notices',
		},
	]
}
